import { render } from "./MapControl.vue?vue&type=template&id=3674d3f3"
import script from "./MapControl.vue?vue&type=script&lang=js"
export * from "./MapControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/freddy/lab/js/cassandratech/ersaf-reflui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__